module.exports = __webpack_public_path__ + "img/map.7a93be1f.png";